$(function () {
	$.ajaxSetup({ headers: { 'AntiXsrfToken': $("[id$='AntiXsrfToken']").val() } });
});
